export default "__VITE_ASSET__CYw_4cLg__"